export const LOGIN_USER = "LOGIN_USER"
export const LOGIN_SUCCESS = "LOGIN_SUCCESS"

export const LOGOUT_USER = "LOGOUT_USER"
export const LOGOUT_USER_SUCCESS = "LOGOUT_USER_SUCCESS"
export const API_ERROR = "LOGIN_API_ERROR"

export const SOCIAL_LOGIN = "SOCIAL_LOGIN"

export const LOGIN_USER_DATA = "LOGIN_USER_DATA"
export const LOGIN_SUCCESS_DATA = "LOGIN_SUCCESS_DATA"
export const LOGIN_DATA_RESET = "LOGIN_DATA_RESET"
export const LOGOUT_USER_CLEAR = "LOGOUT_USER_CLEAR"
export const LOGOUT_USER_SUCCESS_CLEAR = "LOGOUT_USER_SUCCESS_CLEAR"
export const LOGIN_ERROR = "LOGIN_ERROR"
